export class ClientNoteViewModel {
  id?: string;
  clientId: string;
  clientName?: string;
  note: string;
  status: string;
  type: string;
  /** Date range covered by a scheduled outage note. */
  startDate?: Date | string | null;
  endDate?: Date | string | null;
  /** Optional date the note should be followed up on. */
  followUpDate?: Date | string | null;
  /** How a "Resource Request" note was fulfilled; null for every other note type. */
  resourceRequestStatus?: string | null;
  /** Ids of the client's scheduling groups a scheduled outage applies to. */
  schedulingTeamIds?: string[];
  /** Status updates appended to the note over time. */
  updates?: ClientNoteUpdate[];
  dateCreatedUtc: Date;
  dateDeletedUtc?: Date;
  createdByUserId?: string;
  createdByUserName?: string;
}

/** A single status update on a client note. */
export interface ClientNoteUpdate {
  id?: string;
  clientNoteId?: string;
  label?: string;
  internalNotes?: string;
  clientNotes?: string;
  createdByUserId?: string;
  createdByUserName?: string;
  dateCreatedUtc?: Date | string;
  emailedToClient?: Date | string | null;
}

/** Must match ClientNoteTypes.ScheduledOutage on the server. */
export const SCHEDULED_OUTAGE_NOTE_TYPE = "Scheduled Outage";

/** Must match ClientNoteTypes.ResourceRequest on the server. */
export const RESOURCE_REQUEST_NOTE_TYPE = "Resource Request";

/** How a resource request was fulfilled. Values must match the server's stored strings. */
export const RESOURCE_REQUEST_STATUSES = ["Filled", "Partial", "Not Filled"] as const;

/**
 * Note types the client note UI offers. Must match `ClientNoteTypes` on the server (and is shared
 * by both client note UIs so they cannot drift). Driver-only types (e.g. "Complaint") do not belong
 * here even though the modal and the driver note form look similar.
 */
export const CLIENT_NOTE_TYPES = [
  "General",
  "Accident",
  "Breakdown",
  RESOURCE_REQUEST_NOTE_TYPE,
  SCHEDULED_OUTAGE_NOTE_TYPE,
] as const;

/** A scheduled outage note as returned by GET api/client/notes/scheduledOutages. */
export interface ScheduledOutage {
  id: string;
  clientId?: string;
  clientName?: string;
  note?: string;
  startDate?: string | null;
  endDate?: string | null;
  schedulingTeamIds: string[];
  dateCreatedUtc?: string;
  createdByUserName?: string;
}
